/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {EditorUser, MixpanelUserItem} from 'common/widgets/user-list/types';
import {HeaderUserInfo} from 'common/widgets/user-list/types';
import {UserListEl} from 'common/widgets/user-list';
import {IconSizeType} from 'common/constants';

import {formatDate} from './util';

export const CreatorWithViewsIcon = ({
  userListSel,
  slot,
  trackingProps,
  entityEditor,
  entityCreator,
  presenceViews,
  totalPresenceViews,
}: {
  userListSel?: string;
  slot?: string;
  trackingProps?: {[key: string]: string | number};
  entityEditor?: HeaderUserInfo;
  entityCreator?: HeaderUserInfo;
  presenceViews?: MixpanelUserItem[];
  totalPresenceViews: number;
}) => {
  const users: MixpanelUserItem[] = [];

  // First (displayed) icon is creator
  if (entityCreator) {
    const {id, name, email, date} = entityCreator;
    const formattedDate = formatDate(date, `MMM DD, YYYY`);
    users.push({id, name, email, 'label-prefix': `Created by`, 'label-suffix': formattedDate});
  }

  let editorUser: EditorUser;
  if (entityEditor) {
    const {name, email, date} = entityEditor;
    const formattedDate = formatDate(date, `MMM DD, YYYY • h:mm A`);

    editorUser = {name, email, dateStr: formattedDate};
  }

  // If there's only one view, it's the user who just created the entity.
  // Don't show the overflow in that case.
  if (presenceViews?.length > 1) {
    users.push(...presenceViews);
  }

  return users.length ? (
    <UserListEl
      sel={userListSel}
      attrs={{
        users,
        slot,
        'max-icons-displayed': 1,
        elref: `userList`,
        size: IconSizeType.Small,
        'track-properties': trackingProps,
        'editor-user': editorUser,
        'user-count-override': totalPresenceViews > 1 ? totalPresenceViews : 0,
      }}
    />
  ) : null;
};
